// src/app/admindashobard/pages/AdminDashboardPage.jsx

import * as React from "react";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import AdminLayout from "../components/AdminLayout";
import { Colors } from "../../utils/Colors";

function DashboardCard({ title, value }) {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        border: `1px solid ${Colors.border.light}`,
        boxShadow: Colors.shadow.brand,
      }}
    >
      <CardContent>
        <Typography
          sx={{
            fontSize: 15,
            color: Colors.text.sub,
            mb: 1,
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontSize: 28,
            fontWeight: 800,
            color: Colors.brand.primary,
          }}
        >
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default function AdminDashboardPage() {
  return (
    <AdminLayout>
      <Typography
        sx={{
          fontSize: { xs: 28, md: 38 },
          fontWeight: 800,
          color: Colors.text.header,
          mb: 3,
        }}
      >
        This is Admin Dashboard
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4}>
          <DashboardCard title="Total Patients" value="1,284" />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <DashboardCard title="Active Devices" value="96" />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <DashboardCard title="Live Sessions" value="41" />
        </Grid>
      </Grid>
    </AdminLayout>
  );
}